import axios from "axios"

export const removeSubscriberByEmail = async (email: string, listId?: number) => {
  return axios.post(`/api/ecomail/removeSubscribeMember`, {
    email,
    listId
  })
}
